import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { ModalBuyWordsComponent } from '@component/modal-buy-words/modal-buy-words.component';
export class ModalOpenaiDialogComponent {
    constructor(activeModal, authService, usersService, mentorService, modalService) {
        this.activeModal = activeModal;
        this.authService = authService;
        this.usersService = usersService;
        this.mentorService = mentorService;
        this.modalService = modalService;
        this.valueSender = new EventEmitter();
        this.isChecked = false;
        this.requestAiLoading = false;
        this.suggestions = "";
        this.splitedSuggestions = [];
        this.selectedSuggestion = '';
    }
    ngOnInit() {
        this.usersService.getWordsCount(this.authService.user.id).subscribe((res) => {
            this.currentWords = res.words;
            this.maxWords = res.max_words;
        });
    }
    generateTitle(title) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.currentWords >= this.maxWords) {
                const modalRef = this.modalService.open(ModalBuyWordsComponent, { size: 'sm' });
                yield modalRef.result.then(() => {
                    this.activeModal.dismiss();
                }).catch(() => {
                    this.activeModal.close();
                });
                return;
            }
            this.requestAiLoading = true;
            this.splitedSuggestions = [];
            yield this.mentorService.callOpenAi("crie 5 títulos de trabalhos acadêmicos sobre ", title, "gpt-3.5-turbo-instruct", 150, "list", true)
                .then((res) => {
                for (let c = 0; c < res.length; c++) {
                    if (res[c].length > 0) {
                        this.splitedSuggestions.push(res[c]);
                    }
                }
            }).catch((err) => {
                console.error(err);
            });
            this.requestAiLoading = false;
        });
    }
    title() {
        this.valueSender.emit(this.selectedSuggestion);
        this.activeModal.close();
    }
    hasSuggestions() {
        return this.splitedSuggestions.length > 0;
    }
    onSelected(value) {
        this.selectedSuggestion = value;
    }
    passSuggestion() {
        this.activeModal.close(this.selectedSuggestion);
    }
}
